import React from 'react';
import { cn } from '@shared/lib/utils';
import type { SidebarItem } from '../model/sidebar.types';
import { SidebarMenuButton } from './sidebar-menu-button';
import { SidebarCollapseIcon } from './sidebar-collapse-icon';
import { getIcon } from '../lib/icon-map';

interface SidebarFooterProps {
  className?: string;
  items?: SidebarItem[];
  onItemClick?: (item: SidebarItem) => void;
  collapsed?: boolean;
  children?: React.ReactNode;
}

export function SidebarFooter({
  className,
  items,
  onItemClick,
  collapsed,
  children,
}: SidebarFooterProps): React.ReactElement {
  return (
    <footer
      className={cn(
        'mt-auto flex shrink-0 flex-col gap-3 pt-2 pb-6',
        'ps-[var(--layout-sidebar-padding-inline-start,32px)] pe-[var(--layout-sidebar-padding-inline-end,24px)]',
        'transition-[padding,min-height] duration-normal ease-standard',
        collapsed ? 'min-h-0 px-3 pb-4' : 'min-h-20',
        className
      )}
      data-name="SidebarFooter"
    >
      {children}
      {items && (
        <div className="flex w-full flex-col gap-3">
          {items.map((item) => {
            const isCollapseItem = item.id === 'collapse';

            return (
              <SidebarMenuButton
                key={item.id}
                icon={
                  isCollapseItem ? (
                    <SidebarCollapseIcon collapsed={Boolean(collapsed)} />
                  ) : (
                    getIcon(item.icon)
                  )
                }
                label={item.label}
                isActive={item.active}
                collapsed={collapsed}
                variant={isCollapseItem ? 'collapse' : undefined}
                aria-label={isCollapseItem ? item.label : undefined}
                onClick={() => onItemClick?.(item)}
              />
            );
          })}
        </div>
      )}
    </footer>
  );
}
